import type { CommonHTMLAttributes } from '@frontend/types';
import { LoadersStyles } from './loaders.styles';

export type SpinnerSize = 'xl' | 'large' | 'medium' | 'small' | 'xs' | 'xxs';

export type SpinnerColorType =
  | 'primary'
  | 'default'
  | 'light'
  | 'subdued'
  | 'disabled'
  | 'white'
  | 'error'
  | 'success'
  | 'warn';

export type SpinningLoaderProps = CommonHTMLAttributes & {
  size?: SpinnerSize;
  color?: SpinnerColorType;
};

export const SpinningLoader = ({ size = 'large', color = 'primary', ...rest }: SpinningLoaderProps) => {
  const spinnerStyle = LoadersStyles.spinnerStyle({ size, color });
  return (
    <div css={spinnerStyle} role='progressbar' {...rest}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};
